import React, { PureComponent } from "react";
import { connect } from "react-redux";

import styles from './style.css';
import { authByFacebookSigningSelector } from "../../../store/auth-by-facebook/selectors";
import { authByGoogleSigningSelector } from "../../../store/auth-by-google/selectors";
import { loginByFacebook } from "../../../store/auth-by-facebook/actions";
import { loginByGoogle } from "../../../store/auth-by-google/actions";
// import Icon from "app/modules/custom-icons";
import UQButton from "../../../../uq-ui/components/button";
import Icon from "../../../../icons/Icon";
import UiIcon from "../../../../uq-ui/components/ui-icon";

class AuthComponentsAuthSocial extends PureComponent {

  loginByEmail = () => {
    this.props.history.push('/login/email');
  }

  render() {
    return (
      <div className={styles.container}>
        <UQButton
          label="Google"
          icon={<Icon name="SocGoogle" width="26px" height="26px"  />}
          theme="white"
          containerClass={styles.btn}
          onPress={this.props.loginByGoogle}/>
        <UQButton
          label="Email"
          icon={<UiIcon name="mail" size={24} color="var(--c-accent-on-light)"/>}
          containerClass={styles.btn}
          theme="white"
          onPress={this.loginByEmail}/>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isFacebookSigning: authByFacebookSigningSelector(state),
    isGoogleSigning: authByGoogleSigningSelector(state),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    loginByFacebook: () => dispatch(loginByFacebook()),
    loginByGoogle: () => dispatch(loginByGoogle())
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthComponentsAuthSocial);